export default "__VITE_ASSET__BkxoTz1K__"